import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "../../../core/common/config/locales";
import {CRITERIA_LIST} from "../../gridsContants";

@observer
export default class CriteriaList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Criteria`;
  static icon = 'list';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("CriteriaList#fetchData(%s)", CRITERIA_LIST);

    return gridService.fetchGrids(CRITERIA_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(CRITERIA_LIST);
      });
  }

  render() {
    let { params, query } = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(CRITERIA_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/criterion/criteriaList.tsx